export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  features: {
    /**
     * @description default sort order
     * @author Chris Hanson
     * @expires when default sort experiment finishes
     */
    'defaultSort:enrolment': true,
    'experiments:loading-cover': true,
    /**
     * @description Category page
     * @author Marek Wojtaszek
     * @expires
     */
    'category-page': false
  },
  assets_domains: {
    item_thumbnail: 'thumb-tf.s3.envato.com',
    item_image: 'image-tf.s3.envato.com'
  },
  show_category_in_selected_filters: true
}
